/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/style-prop-object */
import React from 'react'
import '../style/speaking.css'
import mystory from '../images/mystory.png'
import work1 from '../images/tran.jpg'


const Speaking = () => {
    return (
        <>
            <section style={{ backgroundColor: '#00415d' }} id='myst'>
                <div className='container' id='syImgCenter' >
                    <div className='row' id='rowVlo' style={{ flexDirection: 'row-reverse' }}>
                        <div className='col' style={{ color: 'white', marginTop: '40px' }}>
                            <h2 id='headMa' >How about we swap stories and glean insights from each other's paths to success? </h2>
                            <h2 id='headMa' style={{ marginTop: '15px' }}>Let's dive in and discover the wisdom waiting to be unearthed from our collective experiences!</h2>
                            <a href="/ContactUs" >
                                <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "50px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                    <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                </button>
                            </a>
                        </div>
                        <div className='col' id='mystRow'>
                            <img src={mystory} id='mystImg2' style={{ marginRight: '20px', marginTop: "100px" }} alt="icon1" />
                        </div>
                    </div>
                </div>
            </section>
            <section >
                <svg id="wave" style={{ transform: 'rotate(180deg)', transition: '0.3s' }} viewBox="0 0 1440 410" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
                            <stop stopColor="rgba(0, 65, 93, 1)" offset="0%"></stop>
                            <stop stopColor="rgba(46.352, 166.342, 218.031, 1)" offset="100%"></stop>
                        </linearGradient>
                    </defs>
                    <path
                        style={{ transform: 'translate(0, 0px)', opacity: 1 }}
                        fill="url(#sw-gradient-0)"
                        d="M0,287L30,266.5C60,246,120,205,180,191.3C240,178,300,191,360,198.2C420,205,480,205,540,232.3C600,260,660,314,720,300.7C780,287,840,205,900,184.5C960,164,1020,205,1080,184.5C1140,164,1200,82,1260,102.5C1320,123,1380,246,1440,307.5C1500,369,1560,369,1620,321.2C1680,273,1740,178,1800,116.2C1860,55,1920,27,1980,54.7C2040,82,2100,164,2160,198.2C2220,232,2280,219,2340,211.8C2400,205,2460,205,2520,225.5C2580,246,2640,287,2700,252.8C2760,219,2820,109,2880,61.5C2940,14,3000,27,3060,68.3C3120,109,3180,178,3240,225.5C3300,273,3360,301,3420,273.3C3480,246,3540,164,3600,129.8C3660,96,3720,109,3780,109.3C3840,109,3900,96,3960,109.3C4020,123,4080,164,4140,150.3C4200,137,4260,68,4290,34.2L4320,0L4320,410L4290,410C4260,410,4200,410,4140,410C4080,410,4020,410,3960,410C3900,410,3840,410,3780,410C3720,410,3660,410,3600,410C3540,410,3480,410,3420,410C3360,410,3300,410,3240,410C3180,410,3120,410,3060,410C3000,410,2940,410,2880,410C2820,410,2760,410,2700,410C2640,410,2580,410,2520,410C2460,410,2400,410,2340,410C2280,410,2220,410,2160,410C2100,410,2040,410,1980,410C1920,410,1860,410,1800,410C1740,410,1680,410,1620,410C1560,410,1500,410,1440,410C1380,410,1320,410,1260,410C1200,410,1140,410,1080,410C1020,410,960,410,900,410C840,410,780,410,720,410C660,410,600,410,540,410C480,410,420,410,360,410C300,410,240,410,180,410C120,410,60,410,30,410L0,410Z">
                    </path>
                </svg>
            </section>
            <section >
                <div className='container'>
                    <div className='row' id='rM'>
                        <div className='col' style={{ textAlign: "center", marginTop: '40px' }}>
                            <h3 id='txtSp' style={{ color: '#00415d', marginLeft: "25px" }}>About Me as a Trainer</h3>
                            <img src={work1} alt="image" id='iM' />
                        </div>
                        <div className='col' id='colD' >
                            <p style={{ fontSize: '17px' }}>
                                From a shy, nervous college student to a powerhouse speaker!
                                <br />
                                I still remember that first lecture, feeling like a deer in headlights in front of 50 students. But fast forward to today, and most of my audience describes me as one of the best speakers they've encountered—full of energy, knowledge, and inspiration.
                            </p>
                            <p style={{ fontSize: '17px', color: '#00415d' }}>"One of the best speaker, full of energy, knowledge & inpiration."</p>
                            <p style={{ fontSize: '17px' }}>
                                It's been 11 years since I earned my first degree, and in that time, I've dedicated myself to speaking, touching the lives of over 40,000 students and individuals from diverse backgrounds.
                            </p>
                            <p style={{ fontSize: '17px' }}>
                            My passion lies in sharing insights on Entrepreneurship Building Skills, Mindset, Profitable Business strategies, and NLP techniques. With a blend of humor, personal anecdotes, and captivating visuals, I can keep audiences engaged for up to 7 hours straight.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Speaking
